import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { hasPermission, useCheckPermissions, useTableFilter } from '@/shared';
import { useFetchUnidadesTransporte } from '@/shared/actions/erp/system-settings';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  
} from '@/shared/components/ui';
import { IDtaUnidadTransporte } from '@/shared/interfaces';
import { PermissionsEnum } from '@/auth/interfaces';

const returnUrl = '/parametrizacion/unidades-transporte';

export interface UnidadesTransportePageInterface {}

const UnidadesTransportePage: React.FC<UnidadesTransportePageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_unidadtransporte);

  const navigate = useNavigate();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex } = pagination;

  ///* fetch data
  const {
    data: UnidadesTransportePagingRes,
    isLoading,
    isRefetching,
  } = useFetchUnidadesTransporte({
    page: pageIndex + 1,
    nombre: searchTerm,
  });

  ///* handlers
  const onEdit = (original:IDtaUnidadTransporte) => {
    navigate(`${returnUrl}/editar/${original.id_unidad_transporte}`);
  };

  ///* columns
  const columns = useMemo<MRT_ColumnDef<IDtaUnidadTransporte>[]>(
    () => [
      {
        accessorKey: 'codigo',
        header: 'codigo',
        size: 300,
      },
      {
        accessorKey: 'numero_referencia',
        header: 'numero referencia',
        size: 300,
      },
      {
        accessorKey: 'placa',
        header: 'placa',
        size: 300,
      },
      {
        accessorKey: 'chofer_nombre',
        header: 'nombre del chofer',
        size: 300,
      },
      {
        accessorKey: 'chofer_identificacion',
        header: 'identificacion del chofer',
        size: 300,
      },
    ],
    []
  );

  return (
    <SingleTableBoxScene title="Unidades de transporte" urlRedirect={`${returnUrl}/crear`} enableRedirect={hasPermission(PermissionsEnum.api_add_unidadtransporte)}>
      <CustomSearch onChange={onChangeFilter} value={globalFilter} text="Unidades de trasnporte" />

      <GeneralTable<IDtaUnidadTransporte>
        columns={columns}
        data={UnidadesTransportePagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={UnidadesTransportePagingRes?.data?.count}
        // // actions
        canEdit={hasPermission(PermissionsEnum.api_change_unidadtransporte)}
        enableColumnActions={hasPermission(PermissionsEnum.api_change_unidadtransporte)}
        // crud
        onEdit={onEdit}
        canDelete={false}
      />
    </SingleTableBoxScene>
  );
};

export default UnidadesTransportePage;
